import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { produceData, produceCategoryLabels } from '../data/produceData';
import { Search, Filter, ChevronRight, Apple } from 'lucide-react';

// AI-Generated images for produce
const produceImages = {
  'alphonso-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/bc8824e58cd3f0cd5e99fdea2ca9eecc649ef76f764289be97e3bc4aa0fcb944.png',
  'kesar-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/f5dc066fe8c0c344c6ff5ec8c2571119b6898cdc853f461887cfebc54b6f5488.png',
  'totapuri-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c171137a69c46b30ea7401bf310c48ee5c704d9538cb918fb2676578e8f25703.png',
  'thompson-grapes': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/e61a6072a834ec7e8508ff71d7eded0ab5f8631d4f500e33fcd88a6f41e49914.png',
  'pomegranate': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/8b2b287dde9feb4c4d615cbf0bd73861196d51d72c53535d28fcb4dd2aafdc7a.png',
  'banana-cavendish': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/b23e84a8fb529cbefa559d2c9a4b68a460412aaccedccc82ebe67e4e0770a412.png',
  'orange-nagpur': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3d17dd193f7c8c6e19b14a06f6f49957432cda23e2e0dfae3630f30c6e88a12e.png',
  'onion-red': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6f665435ecb11e58759a1f3c1d1daf9090460c57a93ef8266700fe3fec121fca.png',
  'potato': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/cd36a1eaf0c0fb7afa1ff12333e3f3853a3ab4e4dab5862bd91206cfcac81a41.png',
  'green-chilli': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6a5754eaaa7b793d5854fc22e1a0c34dc0ab5094592b562df86f45d41df676a7.png',
  'fresh-ginger': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/39ca211fe2610cc5b7db41687e474336eb8b463243f4d749d7aa32690b349099.png',
  'fresh-garlic': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/74a03f1d78f247be851ca0a126d0763ba0007c51161f2232d3788d5f9d8a05cd.png',
  'okra': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/823b6e1acf80446e561020ef8f1b188a9a61a226b036b316356ccfbfc8605a70.png',
  'mango-pulp': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/2dc079e75c9bf452d00ee5a2b5ebbf55899aa00d6987415ff5c35a7c2936ac4b.png',
  'tomato-paste': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/8d7df9705d2e433bb031eb600c57cd2af46edfd485be27936581517d67654e90.png',
  'dehydrated-onion': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/91cbf6fb6eb7a19244de8dde034d6d36de88b86c96c9babb87913393c82a98cb.png',
  'dehydrated-garlic': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ec21f43c4cd14bd81c0806345c7e39a255d1134c607c713bdac85b06d01aca57.png',
  'frozen-vegetables': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/cefa93053f2d01243cb0e9d3eaf7d54ac54013ba298ac273e44ade69775d4677.png',
  'pickle-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6c2e2e5307e863db0f56a60fc47a5f9c5ae0c97540cbe7c9ea65d18f6633ff0f.png',
  'guava-pulp': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/85279c18cae84182b3799fc85fc881027d4a1de2e385f728c4a910b454ffa91e.png',
  'coconut-products': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/a23a9a7060288e4104acd6515c9bfdaadedb3b0876d4d2fe14a952e873555bbb.png',
};

const getProduceImage = (imageKey) => {
  return produceImages[imageKey] || 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=400&h=300&fit=crop';
};

export default function ProduceCatalogue() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredProduce = useMemo(() => {
    return produceData.filter(item => {
      const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           item.botanicalName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           item.description.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const categories = useMemo(() => {
    const cats = [...new Set(produceData.map(p => p.category))];
    return cats.sort((a, b) => {
      const order = ['fresh-fruits', 'fresh-vegetables', 'processed-fruits', 'processed-vegetables'];
      return order.indexOf(a) - order.indexOf(b);
    });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">Fruits & Vegetables</span>
          </nav>
          
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 bg-[#F47D20]/20 rounded-xl flex items-center justify-center">
              <Apple className="w-7 h-7 text-[#F47D20]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold">Fruits & Vegetables</h1>
          </div>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mb-8">
            India exports a wide variety of fresh and processed fruits and vegetables worldwide. Explore our catalogue 
            featuring premium mangoes, grapes, pomegranates, and processed products like pulps and dehydrated vegetables.
          </p>
          
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search fruits, vegetables, processed..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent"
                data-testid="produce-search-input"
              />
            </div>
            <div className="relative">
              <Filter className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full sm:w-auto pl-12 pr-8 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent appearance-none cursor-pointer"
                data-testid="produce-category-filter"
              >
                <option value="all" className="bg-[#263776]">All Categories</option>
                {categories.map(cat => (
                  <option key={cat} value={cat} className="bg-[#263776]">
                    {produceCategoryLabels[cat]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Produce Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex items-center justify-between mb-8">
          <p className="text-gray-600">
            Showing <span className="font-semibold text-[#263776]">{filteredProduce.length}</span> products
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredProduce.map((item) => (
            <Link
              key={item.id}
              to={`/products/produce/${item.id}`}
              className="group bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
              data-testid={`produce-card-${item.id}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={getProduceImage(item.image)}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="absolute top-3 right-3 px-2 py-1 bg-[#F47D20] text-white text-xs font-medium rounded-full">
                  {produceCategoryLabels[item.category]}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-[#263776] group-hover:text-[#F47D20] transition-colors mb-1">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-500 italic mb-2">{item.botanicalName}</p>
                <p className="text-sm text-gray-600 line-clamp-2">
                  {item.description.substring(0, 100)}...
                </p>
                <div className="mt-3 flex items-center text-[#F47D20] text-sm font-medium">
                  View Details
                  <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredProduce.length === 0 && (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No products found</h3>
            <p className="text-gray-500">Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="bg-[#263776] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Premium Quality Produce</h2>
            <p className="text-gray-300 mb-8">
              SPANXPORT sources fresh and processed fruits and vegetables from India's prime agricultural regions.
              Our cold-chain logistics ensure freshness while our processed products meet international food safety standards.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">20+</div>
                <div className="text-sm text-gray-300">Products</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">GI</div>
                <div className="text-sm text-gray-300">Tagged Products</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">Cold</div>
                <div className="text-sm text-gray-300">Chain Logistics</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">GlobalGAP</div>
                <div className="text-sm text-gray-300">Certified Farms</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="bg-gradient-to-r from-[#F47D20] to-[#ff9a4d] rounded-2xl p-8 md:p-12 text-white text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Need Fresh Produce?</h2>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Contact our team for competitive pricing on bulk orders, seasonal availability, 
            and tailored packaging solutions for your business needs.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-white text-[#F47D20] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="produce-catalogue-get-quote-btn"
          >
            Get a Quote
            <ChevronRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
}
